// extracted by mini-css-extract-plugin
export default {"filter-inner":"legal-form_filter-inner__plJ9e","button-container":"legal-form_button-container__9ofKK","table-container":"legal-form_table-container__83Nuc"};